import React from 'react'
import Header4 from 'src/components/Header/Header4'
import {Input, Select, Button, Checkbox, Tabs, Table, Form, message, Pagination} from 'antd'
import './index.css'
import addTable from './img/add.png'
import axios from 'axios'
import * as functionTools from "./functionTools"

const {Option} = Select;
const {TabPane} = Tabs;
const {TextArea} = Input;

class OnlineApi extends React.Component {

    state = {
        paramsFlag: 1,//记录参数项是否被点击，被点击了为1，未点击为0
        bodyFlag: 0,//记录主体项是否被点击，被点击了为1，未点击为0
        rowCount: 2,//默认的参数表有两行

        nowSelectAxiosIndex: -1,
        nowSelectAxios: {},
        apiList: [],

        total: 0,
        currentPage: 1,
        pageSize: 7,
        searchText: "",

        nowSelectTabIndex: "item-1",
        resultValue: "尚未使用接口",
    }

    componentDidMount() {
        this.getOnlineApi()
    }

    getOnlineApi = async (page = 1, keyword = '') => {
        let res = await axios.get(global.url.getFileShare + `/onlineApi/api-page?keyword=${keyword}&limit=10&page=${page}`)
        console.log('getOnlineApi', res)
        if (res.data.code === '200') {
            let {records, total} = res.data.payload
            console.log(records, total)
            this.setState({apiList: records, total: total}, () => this.onSelectApi(records[0], 0))
        } else {
            message.error(res.data.message)
        }
    }

    tabChange = (e) => {
        let indexValue = e.target.attributes["index"].nodeValue;//获取标签的index属性值\
        if (indexValue === "params") {
            this.setState({
                paramsFlag: 1,
                bodyFlag: 0
            })
        } else if (indexValue === "body") {
            this.setState({
                paramsFlag: 0,
                bodyFlag: 1
            })
        }
    }

    addtableRow = () => {
        this.setState({
            rowCount: this.state.rowCount + 1
        })
    }

    returnContent = () => {
        const {nowSelectAxios, nowSelectTabIndex, resultValue} = this.state;
        let plugin;
        if (nowSelectTabIndex === "item-1") {
            const algorToolsColumns = [
                {
                    title: 'KEY',
                    dataIndex: 'KEY',
                    key: 'KEY',
                    // width: "30vw",
                    render: (_, record) => {
                        return <div className='OnlineApi_Key'>
                            {record.isMust ? <div className='OnlineApi_Key_isMust'>*</div> : null}
                            <div>{record.key}</div>
                        </div>
                    }
                },
                {
                    title: 'VALUE',
                    dataIndex: 'VALUE',
                    key: 'VALUE',
                    render: (_, record) => {
                        return <Form.Item key={record.id} name={record.key}
                                          rules={[{required: record.isMust, message: `请输入${record.key}`}]}><Input
                            placeholder={record.valueType}/></Form.Item>
                    }
                },
                {
                    title: 'DESCRIPTION',
                    dataIndex: 'DESCRIPTION',
                    key: 'DESCRIPTION',
                    render: (_, record) => {
                        return <div>{record.description}</div>
                    }
                },
            ]
            plugin = <Form ref={(val) => {
                this.form = val
            }}
                           onFinish={this.onFinish}>
                <Table
                    size={'small'}
                    className='AlgorTools_Table'
                    dataSource={nowSelectAxios && nowSelectAxios.paramsList}
                    columns={algorToolsColumns}
                    pagination={false}
                    loading={this.state.spinning}
                >
                </Table>
            </Form>
        } else if (nowSelectTabIndex === "item-2") {
            plugin = <div className="OnlineApi_TextArea"><TextArea defaultValue={nowSelectAxios.defaultBody}
                                                                   autoSize={{minRows: 15, maxRows: 15}}/></div>
        } else if (nowSelectTabIndex === "item-3") {
            plugin = <div className="OnlineApi_TextArea"><TextArea className="OnlineApi_TextArea"
                                                                   value={this.returnJsonText(resultValue)}
                                                                   autoSize={{minRows: 15, maxRows: 15}}/></div>
        } else {

        }

        return plugin;
    }

    onSubmit = () => {
        if (this.form)
            this.form.submit();
        else
            message.error("表单尚未初始化！");
    }

    onFinish = (form) => {
        console.log("OnlineApi----onFinish", form);
        let sendForm = {
            ...form
        }
        this.getAxios(sendForm);
    }

    onSelectApi = (api, index) => {
        // if (this.state.nowSelectAxiosIndex === index) {
        //     // this.setState({});
        //     return;
        // }
        this.setState({nowSelectAxios: api, nowSelectAxiosIndex: index});
    }

    getAxios = (form) => {
        const {nowSelectAxios} = this.state;
        this.setState({spinning: true});
        let query = functionTools.returnQueryByAxios(form);
        console.log('ceshi', form, query)
        axios.get(`${nowSelectAxios.url}${query}`,
        ).then(res => {
            console.log("getAxios-----", res.data);
            if (res.data.code === "200") {
                message.success("查询成功！");
                let data = res.data;
                this.setState({
                    resultValue: data,
                    nowSelectTabIndex: "item-3",
                })
            } else {
                message.error("查询失败，请检查网络连接……")
            }
            this.setState({spinning: false});
        }).catch((e) => {
            message.error("查询失败，请检查网络连接……")
            console.log(e);
            this.setState({spinning: false});
        })
    }

    returnJsonText = (resultValue) => {
        // let text = JSON.stringify(resultValue);
        // let text = resultValue;
        // text = text.split("\n").join(""); //将所有换行字符去掉
        // text = text.replace(/\s*/g, "");  //替换字符串中所有的空字符串
        let text = JSON.stringify(resultValue, undefined, 2);
        return text;
    }

    apiPageChange = (page) => {
        this.setState({currentPage: page})
        this.getOnlineApi(page, this.state.searchText);
    }

    searchAPI = () => {
        let {searchText, currentPage} = this.state;
        this.setState({currentPage: 1})
        this.getOnlineApi(1, searchText);
    }

    render() {
        const {
            nowSelectAxiosIndex,
            nowSelectAxios,
            paramsFlag,
            bodyFlag,
            rowCount,
            apiList,
            nowSelectTabIndex,
            total,
            currentPage,
            pageSize,
            searchText,
        } = this.state
        const tablelist = []//存储需要渲染的列表行
        return (

            <>
                <Header4></Header4>
                <div className="onlineapi-content-wrap">
                    <div className="onlineapi-content-container">
                        <div className="onlineapi-content-left">
                            <div className="onlineapi-content-left-title">
                                <div className="onlineapi-content-left-title-text">接口列表</div>
                            </div>
                            <div className="onlineapi-content-left-search-wrap">
                                <Input className="onlineapi-content-left-search-input"
                                       placeholder="搜索接口" value={searchText} onPressEnter={this.searchAPI}
                                       onChange={(event) => {
                                           // console.log('搜索关键字：',event.target.value);
                                           if (event.target.value === '') {
                                               // console.log(true);
                                               this.getOnlineApi(currentPage);
                                           }
                                           this.setState({searchText: event.target.value})
                                       }

                                       }></Input>
                                <div className="onlineapi-content-left-search-button" onClick={this.searchAPI}>
                                    <div className="onlineapi-content-left-search-btn-text">搜索</div>
                                </div>
                            </div>
                            <div className="api_list_head">
                                共 {total} 个接口
                            </div>
                            <div className="onlineapi-content-left-apilist">
                                {apiList && apiList.map((api, index) => {
                                    return (
                                        <div
                                            className={nowSelectAxiosIndex === index ? "onlineapi-content-left-api-wrapSelect" : "onlineapi-content-left-api-wrap"}
                                            onClick={() => this.onSelectApi(api, index)}
                                            key={api.apiId}
                                        >
                                            <div className="onlineapi-content-left-api-requiretype">{api.type}</div>
                                            <div className="onlineapi-content-left-api-name">{api.name}</div>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="api_pagination">
                                <Pagination simple current={currentPage} total={total} pageSize={10}
                                            onChange={this.apiPageChange}/>
                            </div>
                        </div>
                        <div className="onlineapi-content-right-wrap">
                            <div className="onlineapi-content-right-title">
                                <div className="onlineapi-content-right-title-text">接口详细信息</div>
                            </div>
                            <div className="onlineapi-content-right-infowrap">
                                <div className="onlineapi-content-right-apiorigin-wrap">
                                    <div className="onlineapi-content-right-infoname">接口来源</div>
                                    <Input className="onlineapi-content-right-infocontent"
                                           value={nowSelectAxios && nowSelectAxios.source}></Input>
                                </div>
                                <div className="onlineapi-content-right-apiurl-wrap">
                                    <div className="onlineapi-content-right-infoname">接口URL</div>
                                    <Input className="onlineapi-content-right-infocontent"
                                           value={nowSelectAxios && nowSelectAxios.url}></Input>
                                </div>
                                <div className="onlineapi-content-right-apirequiretype-wrap">
                                    <div className="onlineapi-content-right-infoname">接口描述</div>
                                    <Input className="onlineapi-content-right-infocontent"
                                           value={nowSelectAxios && nowSelectAxios.description}></Input>
                                </div>
                            </div>

                            <div className="onlineapi-content-right-requirewrap">
                                <div className="onlineapi-content-right-requiretype">
                                    <div
                                        className="onlineapi-content-right-requiretype-name">{nowSelectAxios && nowSelectAxios.type}</div>
                                </div>
                                <Input className="onlineapi-content-right-requireurl" placeholder="输入地址"
                                       disabled={nowSelectAxios && nowSelectAxios.useing}
                                       value={nowSelectAxios && nowSelectAxios.url}></Input>
                                <Button className="onlineapi-content-right-requiretest-button" type="primary"
                                        htmlType="submit" onClick={this.onSubmit}>测试</Button>
                            </div>
                            <div className='OnlineApi_Content'>
                                <Tabs
                                    defaultActiveKey="1"
                                    activeKey={nowSelectTabIndex}
                                    onChange={(e) => this.setState({nowSelectTabIndex: e})}
                                >
                                    <Tabs.TabPane tab="参数" key="item-1">
                                    </Tabs.TabPane>
                                    {nowSelectAxios && nowSelectAxios.body ? <Tabs.TabPane tab="主体" key="item-2">
                                    </Tabs.TabPane> : null}
                                    <Tabs.TabPane tab="结果" key="item-3">
                                    </Tabs.TabPane>
                                </Tabs>
                                {this.returnContent()}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default OnlineApi